// extracted by mini-css-extract-plugin
export default {"wrapper":"BookView_wrapper__1hbhX","favourite-button":"BookView_favourite-button__wwFXI"};